// extracted by mini-css-extract-plugin
export default {"mobileVegvisir":"mobileVegvisir-module--mobileVegvisir--vYESz"};